// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"35dd8bad","563":"0c9fcf0a"}[chunkId] + ".chunk.js";
};